import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
  output,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FormControlComponent, PrimengButtonDirective } from '@web/shared/ui';
import { Nillable } from '@web/utils';
import { ButtonModule } from 'primeng/button';
import { AdminMultimediaDetailsForm } from '../../models/admin-multimedia-details-form';
import { Textarea } from 'primeng/textarea';

type MultimediaDetailsFormGroup = FormGroup<{
  title: FormControl<string>;
  alt: FormControl<Nillable<string>>;
  description: FormControl<Nillable<string>>;
}>;

@Component({
  selector: 'app-multimedia-details-form',
  templateUrl: './multimedia-details-form.component.html',
  styleUrl: './multimedia-details-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonModule,
    FormControlComponent,
    InputTextModule,
    PrimengButtonDirective,
    ReactiveFormsModule,
    Textarea,
  ],
})
export class MultimediaDetailsFormComponent implements OnInit {
  private readonly builder = inject(FormBuilder);

  public readonly data = input<Nillable<AdminMultimediaDetailsForm>>();
  public readonly submitClickEvent = output<AdminMultimediaDetailsForm>();
  public readonly form = this.buildForm();

  public ngOnInit(): void {
    this.fillByData();
  }

  public handleSubmitClick(): void {
    this.submitClickEvent.emit(this.toData());
  }

  private buildForm(): MultimediaDetailsFormGroup {
    /* prettier-ignore */
    return this.builder.group({
      title: this.builder.nonNullable.control<string>('', [Validators.required]),
      alt: this.builder.control<Nillable<string>>(''),
      description: this.builder.control<Nillable<string>>(''),
    });
  }

  private toData(): AdminMultimediaDetailsForm {
    const data = this.form.getRawValue();

    return new AdminMultimediaDetailsForm(
      data.title,
      data.alt,
      data.description,
    );
  }

  private fillByData() {
    const data = this.data();

    this.form.patchValue({
      title: data?.title,
      alt: data?.alt,
      description: data?.description,
    });
  }
}
